import './styles.scss'
import React, { useContext, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { popupIcon } from 'Assets/Icons'
import apiAdapterCoffeeWeb from 'Services/apiAdapter_CoffeeWeb'
import { commonMethods } from 'Utils/commonMethods'
import { CoffeeWebContext } from 'Context/CoffeeWebContext'

const CommoditiesData = () => {
  const { t } = useTranslation()
  const { isMarketLive } = commonMethods
  const { setLoading } = useContext(CoffeeWebContext)

  const [commoditiesData, setCommoditiesData] = useState([])

  useEffect(() => {
    let socket = null
    let interval = null
    let isLiveRef = false

    const connectWebSocket = () => {
      if (socket) return

      setLoading(true)

      socket = new WebSocket(`${process.env.REACT_APP_COMMODITIES_WEBSOCKET_BASE_URL}/api/GetAllMacrosignalCommodityData`)

      socket.onopen = () => {
        console.log('WebSocket connected')
      }

      socket.onmessage = (event) => {
        try {
          const incomingData = JSON.parse(event?.data)

          setCommoditiesData(incomingData?.returnLst)
        } catch (err) {
          setLoading(false)
        } finally {
          setLoading(false)
        }
      }

      socket.onclose = () => {
        console.log('WebSocket closed')
        socket = null
      }
    }

    const closeWebSocket = () => {
      if (socket) {
        socket.close()
        socket = null
      }
    }

    const fetchInitialData = async () => {
      setLoading(true)
      try {
        const response = await apiAdapterCoffeeWeb.getAllCommoditiesData()

        setCommoditiesData(response?.data?.returnLst || [])
      } catch (error) {
        setLoading(false)
      } finally {
        setLoading(false)
      }
    }

    const handleMarketSwitch = async () => {
      const { isMarketActive } = isMarketLive()

      if (isMarketActive) {
        isLiveRef = true
        connectWebSocket()
      } else {
        isLiveRef = false
        await fetchInitialData()
      }
    }

    const checkMarketStatus = async () => {
      const { isMarketActive } = isMarketLive()

      if (isMarketActive && !isLiveRef) {
        isLiveRef = true
        connectWebSocket()
      }

      if (!isMarketActive && isLiveRef) {
        isLiveRef = false
        closeWebSocket()
        await fetchInitialData()
      }
    }

    handleMarketSwitch()

    interval = setInterval(checkMarketStatus, 5000)

    return () => {
      if (socket) socket.close()
      if (interval) clearInterval(interval)
    }
  }, [])

  const formatDate = (dateString) => {
    if (!dateString) return ''

    const date = new Date(dateString)

    const day = String(date.getDate()).padStart(2, '0')

    const monthNames = ['JAN', 'FEB', 'MAR', 'APR', 'MAY', 'JUN', 'JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC']

    const month = monthNames[date.getMonth()]
    const year = date.getFullYear()

    return `${day}-${month}-${year}`
  }

  const getColorClass = (value) => {
    if (!value) return ''

    if (value > 0) {
      return 'positive'
    }
    if (value < 0) {
      return 'negative'
    }

    return 'neutral'
  }

  return (
    <div className="commodities-table-wrapper">
      <table className="market-table">
        <thead>
          <tr>
            <th>{t('DATE')}</th>
            <th>{t('TYPE')}</th>
            <th>{t('PRE_CLOSE')}</th>
            <th>{t('LAST')}</th>
            <th>{t('CHANGE')}</th>
            <th>{t('PERCENT')}</th>
          </tr>
        </thead>

        <tbody>
          {commoditiesData?.map((item, index) => (
            <tr key={index}>
              <td className="date-column">
                <div className="date-with-icon">
                  <div>{formatDate(item?.createdOn)}</div>
                  <img className="popup-icon" src={popupIcon} alt="popup-icon" />
                </div>
              </td>
              <td className={`${getColorClass(item?.chng)} commodity-name`}>{item?.commodityName}</td>
              <td className={getColorClass(item?.chng)}>{item?.close}</td>
              <td className={getColorClass(item?.chng)}>{item?.last || '-'}</td>
              <td className={getColorClass(item?.chng)}>{item?.chng || '-'}</td>
              <td className={getColorClass(item?.chng)}>{item?.percentageVal || '-'}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  )
}

export default CommoditiesData
